import React from 'react';
import HojaCaratula from './base/HojaCaratula';

// Etiquetas EXACTAS de la plantilla (templates/caratula/caratula_art.docx) y en su mismo
// orden: el modal es una vista previa, así que lo que se lee acá tiene que coincidir
// renglón por renglón con el papel. `guardable` marca los que además de imprimirse
// vuelven al cliente/trámite (ver CaratulaArtDocumentoService.persistirDatosGuardables).
//
// Son 21 renglones: ART no lleva POSIBLE 212, LIQ, CUOTA, CIDI, MAIL, DOMICILIO REAL,
// NIVEL EDUCATIVO, REGULARIDAD, APORTES PROVINCIA, DDJJ DE SALUD, PATOLOGÍA ni los turnos
// médicos; y tiene cuatro propios (antigüedad, jornada, accidentes, parte del cuerpo) más
// el renglón RTI, que es el espejo del ART: de la carátula de RTI.
const CAMPOS = {
    rti: { label: 'RTI', tipo: 'sino' },
    ingreso: { label: 'INGRESO', tipo: 'fecha' },
    pacto: { label: 'PACTO', tipo: 'sino' },

    claveFiscal: { label: 'CLAVE FISCAL', tipo: 'clave', guardable: true },
    claveCvss: { label: 'CLAVE CVSS', tipo: 'clave', guardable: true },
    referencia: { label: 'REFERENCIA', tipo: 'texto', resaltada: true },

    apellidoNombre: { label: 'APELLIDO/NOMBRE', tipo: 'texto' },
    dniCuit: { label: 'DNI/CUIT', tipo: 'texto' },
    fechaNacimiento: { label: 'FECHA DE NACIMIENTO', tipo: 'fecha', guardable: true, noFutura: true },
    domicilio: {
        label: 'DOMICILIO', tipo: 'domicilio', estructurado: 'domicilioDniDatos', guardable: true,
        nota: 'Se guarda en el domicilio DNI del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    telefono: {
        label: 'Nº TELEFONICO', tipo: 'texto',
        nota: 'Trae el teléfono propio y los contactos adicionales del cliente. Se editan desde la ficha del cliente.',
    },
    estadoCivil: { label: 'ESTADO CIVIL', tipo: 'estadoCivil', guardable: true },
    conyuge: { label: 'CON', tipo: 'texto', guardable: true },
    relacionDependencia: { label: 'RELACION DE DEPENDENCIA', tipo: 'texto' },
    autonomoMonotributo: { label: 'AUTONOMO O MONOTRIBUTO', tipo: 'texto' },
    observaciones: { label: 'OBSERVACIONES', tipo: 'multilinea', guardable: true },
    antiguedadTrabajo: { label: 'ANTIGÜEDAD EN EL TRABAJO', tipo: 'texto' },
    puestoCargo: { label: 'PUESTO O CARGO QUE OCUPA', tipo: 'texto' },
    jornadaLaboral: { label: 'JORNADA LABORAL', tipo: 'texto', guardable: true },
    accidentesAnteriores: { label: 'TUVO ACCIDENTES ANTERIORES', tipo: 'texto', guardable: true },
    parteCuerpo: { label: 'PARTE DEL CUERPO MÁS DAÑADA', tipo: 'texto', guardable: true },
};

// La cabecera de ART es más chica que la de RTI: una sola cajita con RTI/INGRESO/PACTO.
const CAJAS_CABECERA = [
    ['rti', 'ingreso', 'pacto'],
];

// Bloque principal: cada entrada es una fila. Un array de 2 keys = dos columnas, igual
// que los renglones compuestos del documento.
// CLAVE FISCAL/CVSS y REFERENCIA NO van acá: se dibujan aparte, arriba del recuadro,
// igual que en el papel.
const FILAS_CUERPO = [
    ['apellidoNombre'],
    ['dniCuit'],
    ['fechaNacimiento'],
    ['domicilio'],
    ['telefono'],
    ['estadoCivil', 'conyuge'],
    ['relacionDependencia'],
    ['autonomoMonotributo'],
    ['observaciones'],
    ['antiguedadTrabajo'],
    ['puestoCargo', 'jornadaLaboral'],
    ['accidentesAnteriores'],
    ['parteCuerpo'],
];

// CLAVE FISCAL/CVSS y REFERENCIA van fuera del recuadro, tal como están en el papel.
const FILAS_PREVIAS = [
    ['claveFiscal', 'claveCvss'],
    // Esta carátula no tiene CIDI: la REFERENCIA va sola, a lo ancho.
    ['referencia'],
];

// Cómo se dibuja la hoja: título del documento, las cajitas de arriba, los renglones que
// van fuera del recuadro y el bloque principal. HojaCaratula pone el resto (modal, aviso,
// hoja A4 y botones), que es igual en las ocho carátulas.
const LAYOUT = {
    tituloDoc: 'DATOS PERSONALES',
    leyendaDoc: 'ART',
    cabecera: CAJAS_CABECERA,
    filasPrevias: FILAS_PREVIAS,
    cuerpo: FILAS_CUERPO,
};

/**
 * Modal de la Carátula ART. Muestra los renglones prellenados (lo que ya está en el
 * cliente/trámite, o calculado desde los aportes) y en blanco lo que falta, para completar
 * antes de generar. Al confirmar, "Guardar y generar" persiste los renglones guardables y
 * emite el .docx con el DTO tal cual quedó en el formulario (WYSIWYG).
 */
export default function ModalCaratulaArt(props) {
    return (
        <HojaCaratula
            {...props}
            titulo="Generar Carátula ART"
            nombreDocumento="la Carátula ART"
            campos={CAMPOS}
            layout={LAYOUT}
        />
    );
}
